import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import {
  EligibilityDeterminationCalculateRequest,
  EligibilityDetermination,
  HEARING_ELIGIBILITY_DETERMINATION_TYPE_CODE,
} from "./eligibility-determination.model";

const BASE_PATH = "/api/phms/incarcerated-persons";

const quietHttpOptions = {
  headers: new HttpHeaders({
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
  }),
  withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class EligibilityDeterminationService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  getCurrent(
    incarceratedPersonId: number,
    determinationTypeCode = HEARING_ELIGIBILITY_DETERMINATION_TYPE_CODE,
  ): Observable<EligibilityDetermination> {
    const path = `${BASE_PATH}/${encodeURIComponent(String(incarceratedPersonId))}/eligibility-determinations/current`;
    const url = `${this.appConfig.apiUrl(path)}?determinationTypeCode=${encodeURIComponent(determinationTypeCode)}`;
    return this.http.get<EligibilityDetermination>(url, quietHttpOptions);
  }

  getHistory(
    incarceratedPersonId: number,
    determinationTypeCode = HEARING_ELIGIBILITY_DETERMINATION_TYPE_CODE,
  ): Observable<EligibilityDetermination[]> {
    const path = `${BASE_PATH}/${encodeURIComponent(String(incarceratedPersonId))}/eligibility-determinations/history`;
    const url = `${this.appConfig.apiUrl(path)}?determinationTypeCode=${encodeURIComponent(determinationTypeCode)}`;
    return this.http.get<EligibilityDetermination[]>(url, quietHttpOptions);
  }

  calculateOfficial(
    incarceratedPersonId: number,
    request: EligibilityDeterminationCalculateRequest,
  ): Observable<EligibilityDetermination> {
    const path = `${BASE_PATH}/${encodeURIComponent(String(incarceratedPersonId))}/eligibility-determinations/calculate`;
    return this.http.post<EligibilityDetermination>(
      this.appConfig.apiUrl(path),
      request,
      quietHttpOptions,
    );
  }

  calculateCurrentHearingEligibility(
    incarceratedPersonId: number,
    calculationAsOfDate = todayDateOnlyString(),
  ): Observable<EligibilityDetermination> {
    return this.calculateOfficial(incarceratedPersonId, {
      determinationTypeCode: HEARING_ELIGIBILITY_DETERMINATION_TYPE_CODE,
      calculationAsOfDate,
    });
  }
}

function todayDateOnlyString(): string {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${today.getFullYear()}-${month}-${day}`;
}
